export default __webpack_public_path__ + "static/media/ndmi-legend.ebbaa5b5.png";